/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OwnerMembersPageDtoApiResponse } from '../models/OwnerMembersPageDtoApiResponse';
import type { OwnerMembersRequestDto } from '../models/OwnerMembersRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OwnerMembersService {

    /**
     * @param requestBody
     * @returns OwnerMembersPageDtoApiResponse Success
     * @throws ApiError
     */
    public static postApiV1OwnerMembers(
        requestBody?: OwnerMembersRequestDto,
    ): CancelablePromise<OwnerMembersPageDtoApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/owner/members',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
